
import React from 'react';
import logo from '../Assets/img/logo-small.png';

export default function PdfTemplate({ data, bvocData, department, semester, date, admissionYear }) {
  return (
    <div style={{ margin: '5px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <img src={logo} alt="Logo" style={{ width: '50px', marginBottom: '5px' }} />
      </div>
      <h4 style={{ textAlign: 'center', color: '#581F37' }}>
        <strong>{localStorage.getItem('username')}</strong>
      </h4>
      <p style={{ textAlign: 'center', fontSize: '18px' }}>Admission Year: {admissionYear}</p>
      <p style={{ textAlign: 'center', fontSize: '18px' }}>Semester: {semester}</p>
      <p style={{ textAlign: 'center', fontSize: '18px' }}>
        Department: {department === 3 ? 'All Disciplines' : department == 1 ? 'Single Faculty Disciplines' : department == 2 && 'College Disciplines'}
      </p>
      {data && Object.keys(data).map(subject => (
        <div key={subject} style={{ pageBreakInside: 'avoid', breakInside: 'avoid', marginBottom: '20px' }}>
          <div style={{ backgroundColor: '#c7c7c7', padding: '12px', fontWeight: 'bold' }}>
            {`${subject} - ${data[subject][0].dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}`}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', backgroundColor: '#581F37', color: 'white', fontWeight: 'bold', border: '2px solid #000' }}>
              <div style={{ flex: '25%', padding: '12px', border: '1px solid #000' }}>Course Code</div>
              <div style={{ flex: '25%', padding: '12px', border: '1px solid #000' }}>Course Name</div>
              <div style={{ flex: '15%', padding: '12px', border: '1px solid #000' }}>Faculty Name</div>
              <div style={{ flex: '15%', padding: '12px', border: '1px solid #000' }}>Discipline Name</div>
              <div style={{ flex: '10%', padding: '12px', border: '1px solid #000' }}>Group Name</div>
              <div style={{ flex: '10%', padding: '12px', border: '1px solid #000' }}>Course Type</div>
            </div>
            {Array.isArray(data[subject]) && data[subject].map((course, index) => (
              <div key={index} style={{ display: 'flex', pageBreakInside: 'avoid', backgroundColor: 'white', color: 'black', border: '2px solid #000' }}>
                <div style={{ flex: '25%', padding: '10px',  }}>{course.course_code}</div>
                <div style={{ flex: '25%', padding: '10px',  }}>{course.course_name}</div>
                <div style={{ flex: '15%', padding: '10px',  }}>{course.faculty_name}</div>
                <div style={{ flex: '15%', padding: '10px',  }}>{course.discipline_name}</div>
                <div style={{ flex: '10%', padding: '10px',  }}>{course.group_name}</div>
                <div style={{ flex: '10%', padding: '10px', }}>{course.college_course_type}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {bvocData && Object.keys(bvocData).map(subject => (
        <div key={subject} style={{ pageBreakInside: 'avoid', breakInside: 'avoid', marginBottom: '20px' }}>
          <div style={{ backgroundColor: '#c7c7c7', padding: '12px', fontWeight: 'bold' }}>
            {`${subject}(B.Voc) - ${bvocData[subject][0].dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}`}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', backgroundColor: '#581F37', color: 'white', fontWeight: 'bold', border: '2px solid #000' }}>
              <div style={{ flex: '25%', padding: '12px', border: '1px solid #000' }}>Course Code</div>
              <div style={{ flex: '25%', padding: '12px', border: '1px solid #000' }}>Course Name</div>
              <div style={{ flex: '15%', padding: '12px', border: '1px solid #000' }}>Faculty Name</div>
              <div style={{ flex: '15%', padding: '12px', border: '1px solid #000' }}>Discipline Name</div>
              <div style={{ flex: '10%', padding: '12px', border: '1px solid #000' }}>Group Name</div>
              <div style={{ flex: '10%', padding: '12px', border: '1px solid #000' }}>Course Type</div>
            </div>
            {Array.isArray(bvocData[subject]) && bvocData[subject].map((course, index) => (
              <div key={index} style={{ display: 'flex', pageBreakInside: 'avoid', backgroundColor: 'white', color: 'black', border: '2px solid #000' }}>
                <div style={{ flex: '25%', padding: '10px',  }}>{course.course_code}</div>
                <div style={{ flex: '25%', padding: '10px',  }}>{course.course_name}</div>
                <div style={{ flex: '15%', padding: '10px',  }}>{course.faculty_name}</div>
                <div style={{ flex: '15%', padding: '10px',  }}>{course.discipline_name}</div>
                <div style={{ flex: '10%', padding: '10px',  }}>{course.group_name}</div>
                <div style={{ flex: '10%', padding: '10px', }}>{course.college_course_type}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}